module.exports = __webpack_public_path__ + "static/media/logoMobileSidebarCollapsed.ccb71960.jpg";